module.exports = __webpack_public_path__ + "img/rafting-reduced.d1ae95c2.jpg";